import { RouteObject } from "react-router-dom";
import { NetworkManagementLanding } from "./components/landing/landing";

export interface NetworkManagementRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: NetworkManagementRoute[];
}

export const networkManagementRoutes: NetworkManagementRoute[] = [
  {
    path: "/ax/settings/network-management",
    element: <NetworkManagementLanding />,
  },
];